var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.25c-4.925 0-8.75 3.608-8.75 8.483 0 2.55 1.042 4.759 2.75 6.275a.678.678 0 0 1 .233.5l.05 1.559c.017.5.525.816.984.616L7 17.917a.696.696 0 0 1 .467-.034c.8.217 1.65.334 2.533.334 4.925 0 8.75-3.609 8.75-8.484S14.925 1.25 10 1.25Z",
    fill: "url(#messenger_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.742 12.217 2.566-4.075a1.315 1.315 0 0 1 1.9-.35l2.042 1.533c.192.142.45.142.633 0l2.759-2.092c.366-.283.85.159.6.55l-2.575 4.075a1.315 1.315 0 0 1-1.9.35l-2.042-1.533a.525.525 0 0 0-.633 0l-2.759 2.092c-.366.283-.85-.159-.6-.55h.009Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "messenger_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.625 18.604) scale(18.9587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
};
export default SvgMessenger;